import { Button, MultiSelect } from "@etframework/ui.components";
import {
  forwardRef,
  useCallback,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import { useTranslation } from "react-i18next";

export const SelectUsersDropdown = forwardRef(
  ({ id, click, filter, usersDataSource, onChange, type }, ref) => {
    const { t, i18n } = useTranslation(["CreateBoardModal", "Shared"]);
    const multiSelectRef = useRef(null);
    const [values, setValues] = useState();
    const filteredUsers = useMemo(
      () => usersDataSource?.filter?.(filter),
      [usersDataSource, filter]
    );

    const handleOnChange = (e) => {
      onChange?.(e.value);
      setValues(e.value);
    };

    const onClick = () => {
      const selected = multiSelectRef.current.getValue();
      click(filteredUsers?.filter((x) => selected.includes(x.Id)));
    };

    const clear = useCallback(() => {
      multiSelectRef.current.clear();
    }, []);

    useImperativeHandle(ref, () => ({
      clear,
      getData: () => multiSelectRef.current.getValue(),
    }));

    return (
      <div className="space-y-4 p-3">
        <MultiSelect
          id={id + "_dropdown"}
          htmlFor={id + "_dropdown"}
          ref={multiSelectRef}
          value={values}
          dataSource={filteredUsers ?? []}
          fields={{ value: "Id", text: "Name" }}
          label={t("AddUsername", { type: type })}
          change={handleOnChange}
          locale={i18n?.language}
        />
        <div className="d-flex justify-content-between">
          <div></div>
          <div>
            <Button
              id={id + "_add-to-list-button"}
              text={t("AddToList")}
              onClick={onClick}
              className="select-users-multiselect-btn"
            />
          </div>
        </div>
      </div>
    );
  }
);
